import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    CookieManager,
    setGoogleConsentDefault,
} from "react-cookie-manager";
import {TrackingManager} from "./TrackingManager";

setGoogleConsentDefault();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <CookieManager
          googleConsentMode={{
              waitForUpdate: 500,
              adsDataRedaction: true,
          }}
          cookieCategories={{
              Analytics: true,
              Social: false,
              Advertising: true,
          }}
          initialPreferences={{
              Analytics: false,
              Social: false,
              Advertising: false,
          }}
          translations={{
              title: "Nastavenie cookies",
              message:
                  "Používame analytické cookies na meranie návštevnosti a marketingové cookies na vyhodnocovanie a personalizáciu našich kampaní.",

              buttonText: "Prijať všetky",
              declineButtonText: "Odmietnuť všetky",
              manageButtonText: "Nastaviť cookies",

              privacyPolicyText: "Viac informácií",

              manageTitle: "Nastavenie cookies",
              manageMessage:
                  "Vyberte, ktoré voliteľné cookies nám povolíte. Nevyhnutné cookies sú vždy aktívne.",

              manageEssentialTitle: "Nevyhnutné",
              manageEssentialSubtitle:
                  "Potrebné pre správne fungovanie webovej stránky",
              manageEssentialStatusButtonText: "Vždy aktívne",

              manageAnalyticsTitle: "Analytické cookies",
              manageAnalyticsSubtitle:
                  "Pomáhajú nám pochopiť, ako návštevníci používajú našu stránku.",

              manageAdvertTitle: "Marketingové cookies",
              manageAdvertSubtitle:
                  "Používame ich na meranie a personalizáciu reklamných kampaní.",

              manageCancelButtonText: "Zrušiť",
              manageSaveButtonText: "Uložiť nastavenia",
          }}
          privacyPolicyUrl="https://www.dasato.org/zasady-pouzivania-suborov-cookie-eu/"
          displayType="banner"
          enableFloatingButton
      >
          <TrackingManager />
            <App />
      </CookieManager>
  </React.StrictMode>
);
reportWebVitals();
